import {SelectData} from "../../../../../core/types/records-table.types";

export function selectDataTransform(options: Array<SelectData>): Array<SelectData> {
  return options.filter(option => option.display);
}
